const MAIN_MENU = [
  {
    title: "Home",
    path: "/",
    link: "",
    isActive: false,
    subMenu: false,
  },
  {
    title: "About Us",
    path: "/about-us",
    link: "",
    isActive: false,
    subMenu: false,
  },
  {
    title: "What We Do",
    path: "/what-we-do",
    link: "",
    isActive: false,
    subMenu: false,
  },
  {
    title: "MBRDI Experience",
    path: "/mbrdi-experience",
    link: "",
    isActive: false,
    subMenu: true,
    subMenu: [
      {
        title: "Sustainability Dialogue India",
        path: "/sustainability-25",
        link: "",
        isActive: false,
        subMenu: true,
        subMenu: [
          {
            title: "Year 2025",
            path: "/sustainability-25",
            link: "",
          },
          {
            title: "Year 2024",
            path: "/sustainability-24",
            link: "",
          },
          {
            title: "Year 2023",
            path: "/sustainability-23",
            link: "",
          },
        ],
      },
      {
        title: "Legal and Compliance",
        path: "",
        link: "",
        isActive: false,
        subMenu: true,
        subMenu: [
          {
            title: "Annual Return FY24-25",
            path: "",
            link: "Annual-Return_4.pdf",
          },
          {
            title: "Annual Return FY23-24",
            path: "",
            link: "Annual-Return_3.pdf",
          },
          {
            title: "Annual Return FY22-23",
            path: "",
            link: "Annual-Return_2.pdf",
          },
          {
            title: "Annual Return FY21-22",
            path: "",
            link: "Annual-Return_1.pdf",
          },
           {
            title: "AGM Notice FY25-26",
            path: "",
            link: "AGM_Notice_FY2025-26.pdf",
          },
          {
            title: "AGM Notice FY23-24",
            path: "",
            link: "AGM_Notice_FY2023-24.pdf",
          },
          {
            title: "AGM Notice FY22-23",
            path: "",
            link: "AGM_Notice_FY2022-23.pdf",
          },
          {
            title: "Vehicle Privacy Policy",
            path: "https://mbrdi.co.in/#/vehicle-privacy-policy",
            link: "",
          },
        ],
      },
      {
        title: "Sustainability Garage",
        path: "/sustainability-garage",
        link: "",
        subMenu: false,
      },
      {
        title: "What it means to be MBRDI?",
        path: "/what-it-means-to-be-mbrdi",
        link: "",
        subMenu: false,
      },
      {
        title: "People Practices",
        path: "/people-practise",
        link: "",
        subMenu: false,
      },
      {
        title: "Benefits",
        path: "/benefits",
        link: "",
        isActive: false,
        subMenu: false,
      },
      {
        title: "CSR",
        path: "/csr",
        link: "",
        isActive: false,
        subMenu: false,
      },

      // {
      //   title: "Vehicle Privacy Policy",
      //   path: "/vehicle-privacy-policy",
      //   link: "",
      //   isActive: false,
      //   subMenu: false,
      // },
      // {
      //   title: "Legal & Compliance",
      //   path: "/legal-compliance",
      //   link: "",
      //   isActive: false,
      //   subMenu: true,
      //   subMenu: [
      //     {
      //       title: "Vehicle Privacy Policy",
      //       path: "/vehicle-privacy-policy",
      //       link: "",
      //     },
      //     {
      //       title: "Corporate Governance",
      //       path: "",
      //       link: "",
      //       isActive: false,
      //       subMenu: true,
      //       subMenu: [
      //         {
      //           title: "Annual Return FY23-24",
      //           path: "",
      //           link: "Annual-Return_3.pdf",
      //         },
      //         {
      //           title: "Annual Return FY22-23",
      //           path: "",
      //           link: "Annual-Return_2.pdf",
      //         },
      //         {
      //           title: "Annual Return FY21-22",
      //           path: "",
      //           link: "Annual-Return_1.pdf",
      //         },
      //         {
      //           title: "AGM Notice FY23-24",
      //           path: "",
      //           link: "AGM_Notice_FY2023-24.pdf",
      //         },
      //         {
      //           title: "AGM Notice FY22-23",
      //           path: "",
      //           link: "AGM_Notice_FY2022-23.pdf",
      //         },
      //       ],
      //     },
      //   ],
      // },
      {
        title: "EHS @MBRDI",
        path: "/ehs",
        link: "",
        subMenu: false,
        isActive: false,
      },
    ],
  },
  // {
  //   title: "Legal & Compliance",
  //   path: "/legal-compliance",
  //   link: "",
  //   isActive: false,
  //   subMenu: true,
  //   subMenu: [
  //     {
  //       title: "Vehicle Privacy Policy",
  //       path: "/vehicle-privacy-policy",
  //       link: "",
  //     },
  //     {
  //       title: "Corporate Governance",
  //       path: "",
  //       link: "",
  //       isActive: false,
  //       subMenu: true,
  //       subMenu: [
  //         {
  //           title: "Annual Return FY23-24",
  //           path: "",
  //           link: "Annual-Return_3.pdf",
  //         },
  //         {
  //           title: "Annual Return FY22-23",
  //           path: "",
  //           link: "Annual-Return_2.pdf",
  //         },
  //         {
  //           title: "Annual Return FY21-22",
  //           path: "",
  //           link: "Annual-Return_1.pdf",
  //         },
  //         {
  //           title: "AGM Notice FY23-24",
  //           path: "",
  //           link: "AGM_Notice_FY2023-24.pdf",
  //         },
  //         {
  //           title: "AGM Notice FY22-23",
  //           path: "",
  //           link: "AGM_Notice_FY2022-23.pdf",
  //         },
  //       ],
  //     },
  //   ],
  // },
  {
    title: "Careers",
    path: "/join-us",
    link: "",
    isActive: false,
    subMenu: true,
    subMenu: [
      {
        title: "Join Us",
        path: "join-us",
        link: "",
      },
      {
        title: "Hiring Opportunities",
        path: "/hiring-opportunities",
        link: "",
      },
    ],
  },
  {
    title: "News Room",
    path: "/in-the-news",
    link: "",
    isActive: false,
    subMenu: true,
    subMenu: [
      {
        title: "In the News",
        path: "/in-the-news",
        link: "",
      },
      {
        title: "Press Release",
        path: "/press-release",
        link: "",
      },
    ],
  },
  {
    title: "Contact Us",
    path: "/contact-us",
    link: "",
    isActive: false,
    subMenu: false,
  },
  {
    title: "MBRDI on LinkedIn",
    path: "",
    link: "https://www.linkedin.com/company/mercedes-benz-research-and-development-india",
    isActive: false,
    subMenu: false,
  },
];

const SUSTAINABILITY_23 = [
  {
    title: "Home",
    path: "/sustainability-23",
    link: "",
    isActive: false,
    subMenu: false,
  },
  {
    title: "Event Agenda",
    path: "/event-agenda-23",
    link: "",
    isActive: false,
    subMenu: false,
  },
  {
    title: "Event Report",
    path: "",
    link: "Mercedes-Benz_Sustainability_Dialogue_India_2023_Report.pdf",
    isActive: false,
    subMenu: false,
  },
  {
    title: "Support",
    path: "/support-23",
    link: "",
    isActive: false,
    subMenu: false,
  },
];

const SUSTAINABILITY_24 = [
  {
    title: "Home",
    path: "/sustainability-24",
    link: "",
    isActive: false,
    subMenu: false,
  },
  {
    title: "Event Report",
    path: "",
    link: "Mercedes-Benz_Sustainability_Dialogue_India_2024_Report.pdf",
    isActive: false,
    subMenu: false,
  },
  {
    title: "Support",
    path: "/support-24",
    link: "",
    isActive: false,
    subMenu: false,
  },
];

const SUSTAINABILITY_25 = [
  {
    title: "Home",
    path: "/sustainability-25",
    link: "",
    isActive: false,
    subMenu: false,
  },
  {
    title: "Whitepaper",
    path: "",
    link: "Whitepaper_EV_Charging_India_Ecosystem_Perspectives_Skilling_Opportunities.pdf",
    isActive: false,
    subMenu: false,
  },
  {
    title: "Event Report",
    path: "",
    link: "Mercedes-Benz_Sustainability_Dialogue_India_2025_Report.pdf",
    isActive: false,
    subMenu: false,
  },
  {
    title: "Support",
    path: "/support-25",
    link: "",
    isActive: false,
    subMenu: false,
  },
];

export { MAIN_MENU, SUSTAINABILITY_23, SUSTAINABILITY_24, SUSTAINABILITY_25 };
